import React from 'react'
import { connect } from 'react-redux'
import CartItem from './CartItem'
import { CheckoutSection } from '../../components'
import { translateResourceString } from '../../../util/translationUtility';
import { deleteItemAsync, updateItemQuantityAsync, updateItemQuantity, updateRequiredPartnerIdsAsync } from './cartActionCreators'

const CartList = ({ items, isEditable, onQuantityChange, onDelete, titlesIncludedInLicenseUrl }) => {
    const cartItems = items.map((item) => {
        return (
            <CartItem
                key={item.Id}
                item={item}
                isEditable = {isEditable}
                onQuantityChange={onQuantityChange}
                onDelete={onDelete}
                titlesIncludedInLicenseUrl={titlesIncludedInLicenseUrl}
            />
        );
    });
    return (
        <CheckoutSection label={'Cart Summary'}>
            {cartItems}
        </CheckoutSection>
    );
}

const cartListMapStateToProps = (state) => {
    return {
        items: state.entities.CartItems,
        titlesIncludedInLicenseUrl: state.constants.navigation.titlesIncludedInLicenseEndpoint,
        isEditable: !!!state.ui.onPaymentScreen
    }
}

const cartListMapDispatchToProps = (dispatch) => {
    return {
        onQuantityChange: (id, value) => {
            dispatch(updateItemQuantityAsync({ id, qty: value }));
        },
        onDelete: (id, prevQty) => {
            if (typeof window !== 'undefined' && typeof window.confirm !== 'undefined' && window.confirm(translateResourceString("/Checkout/Cart/DeleteItemConfirmation"))) {
                dispatch(deleteItemAsync({ id }))
                dispatch(updateRequiredPartnerIdsAsync());
            } else {
                dispatch(updateItemQuantity(id, prevQty > 0 ? prevQty : 1))
            }
        }
    }
}

const CartListContainer = connect(cartListMapStateToProps, cartListMapDispatchToProps)(CartList);

export default CartListContainer
